import React from "react"
import { useTranslation } from "react-i18next"

import { hasPermissions } from "apps/auth/auth"
import FeeList from "apps/fees/Fee/FeeList"
import Button from "components/Button/Button"
import Icon from "components/Icon/Icon"
import { actionsColumn } from "components/Table"
import Tooltip from "components/Tooltip/Tooltip"
import { reverse } from "utils/urls"

export default function TourOperatorFeeList(props) {
  const { t } = useTranslation()

  return (
    <FeeList
      tableConfig={{
        endpoint: "/fees/tour-operator-fees",
        title: t("Tour Operator Fees"),
        tableName: "tour-operator-fee-table-config",
        buttons: (
          <>
            {hasPermissions(["add_fees_touroperatorfee"]) && (
              <Button icon="plus" to={reverse("tourOperatorFeeCreate")}>
                {t("Add Fee")}
              </Button>
            )}
          </>
        ),
      }}
      actionsColumn={actionsColumn(obj => (
        <>
          <Tooltip title={t("Fee History")}>
            <Icon.Link
              name="history"
              color="gray"
              to={reverse("history", {
                id: obj.id,
                model: encodeURIComponent("fees/tour-operator-fees"),
              })}
            />
          </Tooltip>
          <Tooltip title={t("Edit Fee")}>
            <Icon.Link
              name="edit"
              linkClassName="ml-3"
              to={reverse("tourOperatorFeeUpdate", { id: obj.id })}
            />
          </Tooltip>
          <Tooltip title={t("Delete Fee")}>
            <Icon.Link
              name="remove"
              color="danger"
              linkClassName="ml-3"
              to={reverse("tourOperatorFeeDelete", { id: obj.id })}
            />
          </Tooltip>
        </>
      ))}
    />
  )
}
